module.exports = __webpack_public_path__ + "static/media/capstone_permissions.abb267b6.yaml";